import styled from 'styled-components';
import { Card, Collapse, Form, Space } from 'antd';

export const PanelContainer = styled.div`
  height: 100%;
  overflow: auto;
`;

export const TabContent = styled.div`
  padding: 12px;
`;

export const StyledCard = styled(Card)`
  background: #1e1e1e;
  margin-bottom: 12px;
  .ant-card-head {
    color: #fff;
  }
  .ant-card-body {
    padding: 12px;
  }
`;

export const StyledCollapse = styled(Collapse)`
  background: #1e1e1e;
  border: none;
  .ant-collapse-header {
    color: #fff !important;
  }
`;

export const CollapseHeader = styled.span`
  // 移除硬编码颜色，使用主题配置
`;

export const FormLabel = styled.span`
  // 移除硬编码颜色，使用主题配置
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 8px;
`;

export const FieldContainer = styled.div`
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
  transition: background-color 0.2s;

  &.selected {
    background-color: rgba(255,255,255,0.1);
    
    &:hover {
      background-color: rgba(255,255,255,0.15);
    }
  }

  &:hover {
    background-color: rgba(255,255,255,0.05);
  }
`;

export const StyledSpace = styled(Space)`
  width: 100%;
`;